import React from 'react';
import { Link } from 'react-router-dom';
import { getSpecializationTerm, isSpecializationDirection, getSpecializationName } from '../utils/organizationHelpers';
import { formatDateLongRu } from '../utils/dateUtils';
import { formatUserDisplayName } from '../utils/userDisplayName';
import './GroupsList.css';

const trainerListKey = (trainer) => {
    const rawId = trainer?.user_id;
    if (rawId !== null && rawId !== undefined && String(rawId).trim() !== '') {
        return `user:${String(rawId).trim()}`;
    }
    return `name:${String(trainer?.name || '').trim().toLowerCase()}`;
};

const GroupsList = ({ groups, loading, orgCode }) => {
    if (loading) {
        return (
            <div className="loading">
                <div className="spinner"></div>
            </div>
        );
    }

    if (!groups || groups.length === 0) {
        return (
            <div className="no-groups">
                <p>Группы не найдены</p>
            </div>
        );
    }

    return (
        <div className="tiles-container" id="tiles-container-id">
            {groups.map(group => {
                // access_data + тренеры из расписания; организатор — только если не скрыт
                const trainersMap = new Map();
                const hideManager = Boolean(group.hide_manager_from_trainers);
                const managerId = group.manager_id != null ? String(group.manager_id) : null;

                if (group.manager_name && !hideManager) {
                    const key = trainerListKey({ user_id: group.manager_id, name: group.manager_name });
                    trainersMap.set(key, {
                        name: group.manager_name,
                        photo_url: group.manager_photo_url
                    });
                }

                if (group.access_data && Array.isArray(group.access_data)) {
                    group.access_data.forEach(access => {
                        if (hideManager && managerId && String(access.user_id) === managerId) return;
                        const key = trainerListKey({ user_id: access.user_id, name: access.name });
                        if (!trainersMap.has(key)) {
                            trainersMap.set(key, {
                                name: access.name,
                                photo_url: access.photo_url
                            });
                        }
                    });
                }

                const scheduleTrainers = group.schedule_trainers;
                if (scheduleTrainers && Array.isArray(scheduleTrainers)) {
                    scheduleTrainers.forEach((t) => {
                        if (hideManager && managerId && String(t.user_id) === managerId) return;
                        const key = trainerListKey(t);
                        if (!trainersMap.has(key)) {
                            trainersMap.set(key, {
                                name: formatUserDisplayName(t) || t.name,
                                photo_url: t.photo_url
                            });
                        }
                    });
                }

                const trainers = Array.from(trainersMap.values());
                const displayTrainers = trainers.slice(0, 3);

                // Проверяем, является ли это специализацией/авторской программой
                const isSpecialization = isSpecializationDirection(group.direction_name, orgCode);
                const displayDirectionName = isSpecialization
                    ? getSpecializationName(group.direction_name, orgCode)
                    : (group.direction_name || 'Группа');
                const specializationTerm = getSpecializationTerm(orgCode);

                return (
                    <Link
                        key={group.id}
                        className="tile"
                        to={`/g/${group.id}`}
                        target="_blank"
                        style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                        <div className="tile-block tile-name">
                            {isSpecialization ? (
                                <>
                                    <div className="tile-specialization-term">{specializationTerm.toUpperCase()}</div>
                                    <p className="tile-specialization-name">{displayDirectionName}</p>
                                </>
                            ) : (
                                <>
                                    <h3>{displayDirectionName}</h3>
                                    {group.nomination && <p>{group.nomination}</p>}
                                </>
                            )}
                        </div>

                        <div className="tile-block tile-date">
                            <td>{formatDateLongRu(group.earliest_event_date)}</td>
                            <p>{group.region_name || 'Не указан'}</p>
                        </div>

                        <div className="tile-block tile-trainers">
                            <div className="trainers-container">
                                {displayTrainers.map((trainer, idx) => (
                                    <div key={idx} className="trainer">
                                        <span className="trainer-photo-link">
                                            {trainer.photo_url ? (
                                                <img
                                                    src={trainer.photo_url}
                                                    alt={trainer.name}
                                                    className="trainer-photo"
                                                />
                                            ) : (
                                                <div className="trainer-photo trainer-photo-placeholder">
                                                    {trainer.name?.charAt(0) || '?'}
                                                </div>
                                            )}
                                        </span>
                                        <p className="trainer-name">{trainer.name?.split(' ').join('\n')}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Link>
                );
            })}
        </div>
    );
};

export default GroupsList;

